module.exports = __webpack_public_path__ + "static/media/JP_VS_EYELASHES02.b0a1ede0.jpg";